import type { FC } from 'react';
import React from 'react';
import { Container } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CashListTransactionTable } from './components/table/CashListTransaction';
import { CashManagementHeaderBreadcrumbs } from './CashOverviewPage';
import { useCashListTransactionFilters } from './useCashListTransactionFilters';
import { useFeatureFlagEnabled } from '@pflegenavi/frontend/feature-flags';
import { FeatureFlag } from '@pflegenavi/shared/api';
import { LoadingContainer } from '@pflegenavi/web-components';

export const CashTransactionsPage: FC = () => {
  const { t } = useTranslation();

  const filtersState = useCashListTransactionFilters();
  const { cashListId } = filtersState;
  const hasAccountingPaymentsNew = useFeatureFlagEnabled(
    FeatureFlag.AccountingPaymentsNew
  );

  if (!cashListId) {
    return (
      <Container maxWidth={'lg'}>
        <CashManagementHeaderBreadcrumbs
          pageTitle={
            hasAccountingPaymentsNew
              ? t('accounting.nav.transactions')
              : t('nav.cash-management.cash-transactions')
          }
        />
        <LoadingContainer />
      </Container>
    );
  }

  return (
    <Container maxWidth={'lg'}>
      <CashManagementHeaderBreadcrumbs
        pageTitle={
          hasAccountingPaymentsNew
            ? t('accounting.nav.transactions')
            : t('nav.cash-management.cash-transactions')
        }
      />
      <CashListTransactionTable
        cashListId={cashListId}
        filtersState={filtersState}
      />
    </Container>
  );
};

export default CashTransactionsPage;
